module.exports = __webpack_public_path__ + "static/media/blueprint-login.01355ed7.svg";